import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ac46884"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-md-12 flex-container" }
const _hoisted_2 = { class: "tw-bg-white tw-w-[630px] tw-rounded-[6px] box-shadow-contain sm:tw-pl-[70px] sm:tw-pr-[216px] sm:tw-pt-[61px] sm:tw-pb-[56px] tw-p-[20px] tw-z-[1] contain-responsive" }
const _hoisted_3 = { class: "tw-text-[#0345BD] tw-text-[26px] tw-font-semibold tw-mb-[0px]" }
const _hoisted_4 = { class: "tw-text-[#231F20] tw-text-[12px] tw-font-medium tw-mt-[25px] tw-mb-[11px]" }
const _hoisted_5 = ["placeholder", "onKeydown"]
const _hoisted_6 = { class: "tw-mt-[18px] tw-text-[#878787] tw-text-[13px] tw-font-normal tw-leading-[150%] tw-mb-[46px]" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "tw-h-[39px] tw-w-[39px] tw-text-[#FFF]" }

import BrandPattern2 from "@/components/prospect/brandPattern/brandPattern2.vue";
import VendorBasicPage from "./vendorBasicPage.vue";
import { onBeforeMount, onBeforeUnmount, onMounted, Ref, ref } from "vue";
import Utils, { getComponentUiText } from "@/utils/utilities";
import { load } from "recaptcha-v3";
import { useRouter, useRoute } from "vue-router";
import { postExternalCallback } from "@/services/vendor";
import get from "lodash/get";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { Vendor } from "@/services/apiRoutes/routes";
import { successStatusCodes } from "@/utils/constants";
import store from "@/store";
import ProgressAnimation from "../../assets/animation/progress_dark.json";
import { LottieAnimation } from "lottie-web-vue";
import { jwtDecode } from "jwt-decode";


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorAssessmentsCallback',
  setup(__props) {

const route = useRoute();
const token: any = ref("");
const router = useRouter();
const secret = ref("");
const isLoadingAPI = ref(false);
const innerTextVerifyBtnRef: Ref = ref(null);
const animationWidth = ref(0);
const isShowModal = ref(false);

onBeforeMount(async () => {
  const decode: any = await jwtDecode(route.query.token as string, {
    header: true,
  });
  const finalKey = await Utils.getV3Recaptcha();
  const recaptcha = await load(`${finalKey}`);
  isShowModal.value = !decode?.secretDisabled;
  if (decode?.secretDisabled) {
    router.push({
      name: "AssessmentVendorInput",
    });

    const res = await postExternalCallback(
      {
        token: route.query.token,
      },
      recaptcha,
    );
  }
});

const getRecaptcha = async () => {
  try {
    const finalKey = await Utils.getV3Recaptcha();
    const recaptcha = await load(`${finalKey}`);
    return await recaptcha.execute("submit");
  } catch (error: any) {
    router.push({ path: "/" });
  }
};

const beforeUnmount = () => {
  if (document.body.classList.contains("page-opacity")) {
    document.body.classList.remove("page-opacity", "page-bg", "page-shadow");
  }
};

const submit = async () => {
  if (isLoadingAPI.value) return;
  isLoadingAPI.value = true;
  if (innerTextVerifyBtnRef.value) {
    animationWidth.value = innerTextVerifyBtnRef.value.getBoundingClientRect()[
      "width"
    ] as number;
  }
  try {
    const recaptcha = await getRecaptcha();
    token.value = route.query.token;
    const res = await postExternalCallback(
      {
        token: token.value,
        secret: secret.value,
      },
      recaptcha,
    );
    if (res.status === successStatusCodes.OK) {
      showSuccessToast(
        getComponentUiText("app-user-verify-successful-email-1"),
      );
      store.dispatch("Vendor/fetchVendorRequestedExternalInput");
    }

    // const langId = get(res, "data.data.langId", "");
  } catch (error: any) {
    isLoadingAPI.value = false;
    showErrorAPI(error, Vendor.getRequestedAssessment);
  }
};

onBeforeUnmount(() => {
  beforeUnmount();
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(VendorBasicPage, {
    "main-class": "overflow-x-hide overflow-y-hide",
    "body-class": "tw-flex tw-items-center tw-justify-center tw-h-[100%]"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(BrandPattern2, {
          page: "LOGIN",
          "class-name": "automation"
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(getComponentUiText)(
            "app-vendor-assessment-external-callback-modal-title-1",
          )), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(getComponentUiText)(
            "app-vendor-assessment-external-callback-modal-subtitle-1",
          )), 1),
        _createElementVNode("input", {
          id: "vendor-assessment-external-callback-secret",
          "data-cy": "vendor-assessment-external-callback-secret",
          class: "form-control form-input",
          tabindex: "0",
          placeholder: 
          _unref(getComponentUiText)(
            'app-user-forgot-password-enter-key-place-holder-input-text-1',
          )
        ,
          onKeydown: _withKeys(submit, ["enter"]),
          onInput: _cache[0] || (_cache[0] = (e) => (secret.value = e?.target?.value || ''))
        }, null, 40, _hoisted_5),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(getComponentUiText)(
            "app-vendor-assessment-external-callback-modal-hint-1",
          )), 1),
        _createElementVNode("button", {
          type: "button",
          "data-cy": "verify-secret-key-btn",
          class: _normalizeClass(`tw-bg-[#0345BD] tw-border-[#0345BD] ${
          !secret.value || secret.value.length < 1 ? 'btn-disabled ' : ''
        }btn btn-primary letsgo-button tw-flex tw-items-center tw-justify-center tw-h-[47px] tw-rounded-[30px] box-shafow-button tw-py-[9px] tw-px-[22px] tw-text-[18px] tw-font-semibold`),
          tabindex: "3",
          disabled: !secret.value || secret.value.length < 1,
          onClick: submit
        }, [
          (!isLoadingAPI.value)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                ref_key: "innerTextVerifyBtnRef",
                ref: innerTextVerifyBtnRef
              }, _toDisplayString(_unref(getComponentUiText)("app-user-verify-email-verify-button-text-1")), 513))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                style: _normalizeStyle({ width: animationWidth.value + 'px' }),
                class: "tw-flex tw-justify-center"
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_unref(LottieAnimation), {
                    ref: "anim",
                    "animation-data": _unref(ProgressAnimation),
                    "auto-play": true,
                    loop: true
                  }, null, 8, ["animation-data"])
                ])
              ], 4))
        ], 10, _hoisted_7)
      ])
    ]),
    _: 1
  }, 512)), [
    [_vShow, isShowModal.value]
  ])
}
}

})